let ratio = .1;

const options = {
  root: null,
  rootMargin: '0px',
  threshold: ratio
}

const handleIntersect = function (entries, observer) {
  entries.forEach(function (entry) {
    /*
    if (entry.intersectionRatio > ratio) {
      entry.target.classList.remove('reveal')
        observer.unobserve(entry.target)
    }
    */
    if (entry.isIntersecting) {
      entry.target.classList.remove('reveal')
      observer.unobserve(entry.target)
    }
  })
}

export function triggerRevealScroll()
{
    const observer = new IntersectionObserver(handleIntersect, options)
    document.querySelectorAll('.reveal').forEach(function (r) {
      observer.observe(r)
    })

}